import KiziNLResource from '@/resources/KiziNLResource';

export default class KiziNL {
    constructor() {
        this.Resource = new KiziNLResource()
    }

    async connect (websiteId) {
        return await this.Resource.connect(websiteId)
    }
}
